const hu = {
    actionAlready: "Még nem regisztrált? Jelentkezzen be",
    actionExit: "Kijelentkezés",
    actionLogin: "BEJELENTKEZÉS",
    actionRegister: "REGISZTRÁCIÓ",
    actionSave: "MENTÉS",
    actionStart: "KEZDÉS",
    actionContinue: "FOLYTATÁS",
    actionReset: "ÉRTÉKELÉS ÚJRAINDÍTÁSA",
    actionDoDiagnost: "DIAGNOSZTIKA MEGJELENÍTÉSE",
    actionYes: "Igen",
    actionNo: "Nem",
    actionNext: "TOVÁBB",
    actionBusinessCase: "VÁLLALAT JÓ GYAKORLATÁNAK MEGTEKINTÉSE",
    actionBusinessCases: "VÁLLALATOK JÓ GYAKORLATAINAK MEGTEKINTÉSE",
    actionOpenUrl: "URL MEGNYITÁSA",
    actionFilter: "SZŰRŐ",

    /** HOME */
    msgHomeTitleOne: "Mérje fel és növelje bútorgyártó vállalatának körforgásos érettségi szintjét",
    msgHomeSubTitle: "A FurnCIRCLE Online Eszköz értékeli vállalata körforgásos érettségi szintjét a megvalósított körforgásos tervezési stratégiák alapján",

    msgHomeSection2: "Mérje fel és fejlessze bútorgyártó vállalata körforgásos gazdasági érettségét",
    msgHomeSection2Text: "<span style='font-weight:bold;'>FurnCIRCLE Körforgásos Gazdaság Értékelő Eszköz</span><br/><br/>A FurnCIRCLE egy online önértékelő eszköz, amely segíti a bútorgyártókat körforgásos gazdasági érettségük felmérésében és a fejlesztési lehetőségek azonosításában.<br/><br/><span style='font-weight:bold;'>Készen áll körforgásos érettségének felmérésére?</span><ul style='padding-left: 20px'><li>Válaszoljon a vállalatában bevezetett körforgásos tervezési stratégiákkal kapcsolatos kérdésekre.</li><li>Fedezze fel vállalata körforgásos gazdasági érettségi szintjét.</li><li>Azonosítson stratégiákat és bevált gyakorlatokat, amelyek segítik vállalatát a következő szintre lépésben.</li><li>Tanuljon valós iparági példákból, és folyamatosan javítsa körforgásos teljesítményét.</li></ul>",
    msgHomeSection21Text: "<span style='font-weight:bold;'>Járuljon hozzá az európai bútoripari körforgásossági értékeléshez | R-evolve projekt</span><br/><br/>A FurnCIRCLE-t jelenleg a <a href='https://r-evolve.eu/' target='_blank' rel='noopener noreferrer'>R-evolve projektben</a> használják az európai bútoripar körforgásos gazdasági érettségének értékelésére. <span style='font-weight:bold;'>Európa-szerte több mint 400 vállalat</span> kap meghívást a részvételre, hogy segítsen feltérképezni az iparág jelenlegi körforgásossági szintjét.<br/><br/>Vegyen részt az értékelésben, értékelje vállalatát, és járuljon hozzá az ágazat jövőjének alakításához.<br/><br/>Minden adatot bizalmasan kezelünk, és kizárólag aggregált formában használunk fel benchmark- és kutatási célokra. <span style='font-weight:bold;'>A résztvevők hozzáférést kapnak az aggregált benchmark eredményekhez</span>, így összehasonlíthatják teljesítményüket az ágazati átlagokkal a részt vevő európai bútoripari vállalatok anonimizált és aggregált adatai alapján.<br/><br/>Az értékelés kitöltése körülbelül 30-45 percet vesz igénybe.",
    msgHomeSection3: "Partnerek",
    msgHomeSection2Btn: "Kezdje el az értékelést",
    msgHomeSection3Btn: "KAPCSOLAT",

    /** HEADER */
    msgHeader1: "Körforgásos tervezési stratégiák és jó gyakorlatok",
    msgHeader4: "Bejelentkezés",

    /** DRAWER */
    msgCompany: "VÁLLALAT",
    msgDrawer1: "1. Válaszolás",
    msgDrawer2: "2. Értékelés",
    msgDrawer3: "3. Fejlesztés",
    msgDrawer4: "Stratégiai gyűjtemény",
    msgDrawer6: "Beállítások",
    msgDrawer7: "Kijelentkezés",

    /** LOGIN */
    msgWelcome: "Üdvözöljük",
    msgWelcomeSubtitle: "Kérjük, jelentkezzen be a folytatáshoz",

    /** REGISTER */
    msgGetStarted: "Kezdés",
    msgGetStartedSubtitle: "Ez az önértékelési eszköz ingyenes és bizalmas",

    msgFirstname: "Keresztnév",
    msgLastname: "Vezetéknév",
    msgEmail: "E-mail",
    msgPassword: "Jelszó",
    msgConfirmPassword: "Jelszó megerősítése",
    msgCompanyUser: "Vállalat vagy felhasználónév",

    msgLegalRegister: "Elolvastam és elfogadom az <a href='https://ambitcluster.org/en/privacy-policy'>Adatvédelmi irányelveket.</a>",
    errorLegalRegister: "A folytatáshoz el kell olvasnia és el kell fogadnia az Adatvédelmi irányelveket",
    msgLegalRegisterText: "Megjegyzés: Az AMBIT személyes adatokat gyűjt a FurnCIRCLE eszközön keresztül kizárólag technikai és működési célokra. A felmérésre adott válaszokat az R-evolve projekt keretében elemzik. Személyes adatokat vagy vállalatot azonosító információkat nem osztanak meg az R-evolve konzorcium partnereivel. Minden választ szigorúan anonim alapon elemeznek. Statisztikai célokra az adatok ország vagy tevékenységi szektor szerint összesíthetők. A fejlesztő által generált eredményeket semmilyen körülmények között nem kapcsolják össze vagy használják fel egyedi vállalat azonosítására.",

    msgNotRegister: "Még nem regisztrált? <b>Hozzon létre egy fiókot itt</b>",
    msgAlreadyRegister: "Már regisztrált? <b>Jelentkezzen be itt</b>",

    /** HOME TOOL */
    msgClickImage: "Kattintson a lineáris és körforgásos modell rendszerének kibővítéséhez.",

    msgArea: "TERÜLET",
    msgProgress: "MEGVÁLASZOLT KÉRDÉSEK",

    msgAssessmentAreas: "Körforgásos tervezési stratégiák és termék-életciklus",
    msgAssessmentDesc: "A körforgásos tervezési stratégiákat főként a termékek tervezési és fejlesztési szakaszában alkalmazzák. (Pozitív) hatásuk azonban a termék életciklusának egy vagy több későbbi szakaszában jelentkezik, az értékesítés utáni szolgáltatások támogatásával. Ezért a körforgásos tervezési stratégiák egyik osztályozási módja az, hogy az életciklus azon szakasza szerint csoportosítjuk őket, amelyre hatnak: tervezés, anyagi erőforrások, gyártás, elosztás, használati fázis és életciklus vége.<br/><br/>A körforgásossági stratégiák kibontakoztatásához kulcsfontosságú a vállalat általános megközelítése a jövőbeli Körforgásos Gazdaság felé, valamint az ESPR által bevezetett, a fenntartható termékek ökodizájnjáról szóló európai rendelet (ESPR) 5. cikk (1) bekezdésében meghatározott 'termékszempontok' és a Digitális Termékútlevél (DPP).<br/><br/>Az ESPR az EU stratégiájának egyik pillére egy erőforrás-hatékony, alacsony toxicitású és klímabarát Körforgásos Gazdaság (CE) megvalósításában. Olyan keretrendszert hoz létre, amely kötelező piacra lépési feltételeket ír elő a termékek számára, és ambiciózus környezeti, illetve erőforrás-hatékonysági célok teljesítését követeli meg a bolygóhatárokon belül maradás érdekében. Az 5. cikk (1) bekezdés szerinti 'termékszempontok' alapján a termékeket hosszú használatra, könnyű javíthatóságra, újrahasználatra és felújításra, valamint biztonságos újrahasznosításra (más néven R-stratégiák) kell tervezni. Ezenfelül mentesnek kell lenniük problémás anyagoktól, és alkalmasnak kell lenniük a magas minőségű anyag-visszanyerésre.<br/><br/>A DPP, amelyet az ESPR vezet be, azt a megfelelő harmonizált termékadat-infrastruktúrát hivatott biztosítani, amely átláthatóságot, nyomon követhetőséget és fenntartható üzleti innovációt ösztönöz.<br/><br/>Részletekért lásd a R-evolve tájékoztatót | <a href='https://r-evolve.eu/' target='_blank' rel='noopener noreferrer'>https://r-evolve.eu/</a><br/><br/><span style='font-weight:bold;'>Kérjük, válaszolja meg az összes kérdést minden blokkra vagy életciklus-fázisra vonatkozóan, határozza meg körforgásos érettségi szintjét, és tervezze meg fejlesztését, valamint átmenetét egy fejlettebb Körforgásos Gazdaság felé.</span>",

    msgAssessment: "FurnCIRCLE Értékelés",
    msgNotApply: "Jelöld meg az összes választ, amely vonatkozik a vállalatod jelenlegi körforgásos teljesítményére. A válaszok automatikusan elmentésre kerülnek.",
    msgMarkImportant: "Jelölje meg fontosként",
    msgComment: "Megjegyzés",
    msgCommentHolder: "Ide írhat bármilyen kapcsolódó információt vagy saját megjegyzést.",

    /** ANSWER */
    msgPerformance: "Értékelési jelentés",
    msgPerformanceSubtitle: "Tekintse meg vállalata körforgásos érettségi indexét és termékei életciklusának minden fázisát.",
    msgCompanyLevel: "Vállalat körforgásos érettségi indexe (0%-100%)",
    msgBlockArea: "ÉLETCIKLUS FÁZIS",
    msgBlockValues: "ÉRTÉKEK",

    /** ASSESS */
    msgImprovement: "Fejlesztési jelentés",
    msgImprovementMainSubtitle: "Tudja meg, mit tehet vállalata körforgásosságának folyamatos javítása érdekében. Ismerje meg a tervezési stratégiákat és a vállalatok bevált gyakorlatait, hogy vállalatát a következő szintre emelje.</br></br>Azok az életciklus fázisok és körforgásos tervezési stratégiák, amelyek „piros” címkével/körrel rendelkeznek, a maximális értékük 25%-át vagy annál kevesebbet teljesítik, ezért elsődleges prioritásként kezelendők a vállalat körforgásosságának javítása érdekében. Azok a fázisok vagy stratégiák, amelyek „narancssárga” címkével/körrel rendelkeznek, 25% és 75% közötti teljesítményszinttel bírnak, így szintén fontos ezek fejlesztésével foglalkozni. Azok a fázisok vagy stratégiák, amelyek „zöld” címkével/körrel rendelkeznek, 75% feletti teljesítményszinttel bírnak, így kevésbé sürgető a fejlesztésük.",
    msgImprovementSubtitle: "Tudja meg, mit tehet vállalata körforgásosságának folyamatos javítása érdekében. Ismerje meg a tervezési stratégiákat és a vállalatok bevált gyakorlatait, hogy vállalatát a következő szintre emelje.",
    msgLifecyclePhases: "Életciklus fázisok",
    msgLifecycleIndex: "Fázis körforgásossági indexe",
    msgActionsToImplement: "Végrehajtandó intézkedések:",
    msgBaselineScore: "Kezdeti pontszámom",
    msgBusinessCaseEmpty: "Gratulálunk! Ön már megvalósította az ebbe a kategóriába tartozó főbb stratégiákat",

    msgCat1: "GAZDASÁGI ÉS SZERVEZETI",
    msgCat2: "TÁRSADALMI",
    msgCat3: "KÖRNYEZETI",

    /** STRATEGIES COLLECTION */
    msgStrategiesSubtitle: "Böngésszen és fedezze fel a FurnCIRCLE projekt teljes körforgásos tervezési stratégia- és bevált gyakorlati gyűjteményét.",
    msgLifecyclePhase: "Életciklus fázis",
    msgDifficulty: "Végrehajtás nehézsége",
    msgBusinessDynamics: "Értékteremtés vagy értéknyújtás",
    msgBusinessFactors: "Értékajánlat / Költségek / Előnyök",

    /** SETTINGS */
    msgUserInfo: "Felhasználói információk",
    msgUserCredentials: "Felhasználói hitelesítő adatok",

    /** MODAL */
    msgAreSure: "Biztos benne?",

    msgSuccess: "Az adatok sikeresen frissítve",
    msgDeleteSuccess: "Az adatok sikeresen törölve",

    /** ALT TEXT */
    msgSaveCommentAlt: "Mentés a “Megjegyzés” számára. A kérdésekre adott válaszokat nem szükséges elmenteni; azok automatikusan mentésre kerülnek.",
    msgDifficultyAlt: "Ez a címke a körforgásos tervezési stratégia megvalósításának nehézségét jelzi.",
    msgBusinessBlockAlt: "Ez a címke azt jelzi, hogy a CANVAS modell melyik üzleti blokkja (Értékteremtés vagy Értékszállítás) érintett a körforgásos tervezési stratégia megvalósításában.",
    msgImpactBlockAlt: "Ez a címke azt jelzi, hogy a CANVAS modell melyik hatásblokkja (Költségek, Előnyök vagy Értékajánlat) érintett a körforgásos tervezési stratégia megvalósításában.",

    /** ERROR */
    errorOblData: "Töltse ki az összes kötelező mezőt",
    errorEmailFormat: "Hibás e-mail formátum",
    errorUserIncorrect: "Hibás e-mail/jelszó",
    errorSend: "Kommunikációs hiba, kérjük, várjon és próbálja újra később",
    errorLength: "A karakterek maximális száma túllépve",
    errorPassSame: "A jelszavak nem egyeznek meg",

    /** RECOVERY PASS */
    msgRecoveryPassword: "Jelszó helyreállítása",
    msgRecoveryPasswordSubtitle: "Kérjük, adja meg e-mail címét, hogy jelszó-visszaállító kódot kapjon.",
    msgCode: "Kód",
    msgNewPassword: "Új jelszó",
    actionRequestCode: "KÓD IGÉNYLÉSE",
    actionUpdate: "FRISSÍTÉS",
    actionBack: "VISSZA",
    msgForgetPassword: "Elfelejtette a jelszavát?",
    errorRecovery: "Hiba a jelszó helyreállítása során, kérjük, ellenőrizze a megadott kódot",

    /** FOOTER */
    msgFooterContact: "KAPCSOLAT",

    msgFooterGr: "Az Európai Unió által finanszírozott projekt. A kifejtett vélemények kizárólag a szerző(k) álláspontját tükrözik, és nem feltétlenül egyeznek az Európai Unió álláspontjával. Sem az Európai Unió, sem a támogatást nyújtó hatóság nem vonható felelősségre ezekért. Pályázati kiírás és támogatási szerződés hivatkozási száma: SOCPL-2022-SOC-DIALOG-01 (Projekt 101102389)",
    msgCopyright: "Copyright&copy;2025 AMBIT. Minden jog fenntartva",

    msgFooterLegal: "Jogi nyilatkozat",
    msgFooterPrivacy: "Adatvédelem",
    msgFooterCookies: "Süti szabályzat",

    /** PROGRESS VALUES */
    msgProgress0: "Körforgásos tervezési stratégiák",

    /** COMPANY SIZES */
    msgCompanySize: "Vállalat mérete",
    msgCompanySize1: "Kevesebb mint 10 alkalmazott",
    msgCompanySize2: "10-30 alkalmazott",
    msgCompanySize3: "30-50 alkalmazott",
    msgCompanySize4: "Több mint 50 alkalmazott",

    /** PRODUCT TYPES */
    msgProductType: "Az Ön által gyártott terméktípusok",
    msgProductType1: "Hálószobabútorok és ágyak",
    msgProductType2: "Gyerek / ifjúsági hálószobák",
    msgProductType3: "Alvásrendszerek: matracok és alapok",
    msgProductType4: "Nappali bútorok",
    msgProductType5: "Székek",
    msgProductType6: "Konyhák",
    msgProductType7: "Kárpitozott bútorok",
    msgProductType8: "Kültéri bútorok",
    msgProductType9: "Lapra szerelt / DIY bútorok",
    msgProductType10: "Bútorok egészségügyi és ápolási intézményekbe (kórházak, idősek otthona stb.)",
    msgProductType11: "Bútorok közterekre (repülőterek, templomok, színházak és mozik), ülőbútorok nélkül",
    msgProductType12: "Egyedi lakossági bútorok",
    msgProductType13: "Kiegészítők - Kiegészítő elemek",
    msgProductType14: "Kiegészítők - Dekorációs tárgyak",
    msgProductType15: "Kiegészítők - Textíliák",
    msgProductType16: "Kereskedelmi berendezések (retail / contract interiors)",
    msgProductType17: "Félkész termékek bútorokhoz",
    msgProductType18: "Egyéb bútorok",
    msgProductType19: "Fürdőszobabútorok (munkalapokkal együtt)",
    msgProductType20: "Irodabútorok",
    msgProductType21: "Irodai válaszfalak / falak",
    msgProductType22: "Irodai ülések",
    msgProductType23: "Nyilvános ülések / ülések közösségi terekbe",
    msgProductType24: "Akusztikai panelek / akusztikai bútorok",
    msgProductType25: "Irodabútor-alkatrészek",
    msgProductType26: "Egyéb irodabútorok / felszerelések",
    msgProductType27: "Oktatási bútorok",

    /* COUNTRIES */
    msgCountry: "Ország",
    msgAfghanistan: "Afganisztán",
    msgAlbania: "Albánia",
    msgAlgeria: "Algéria",
    msgAmericanSamoa: "Amerikai Szamoa",
    msgAndorra: "Andorra",
    msgAngola: "Angola",
    msgAnguilla: "Anguilla",
    msgAntarctica: "Antarktisz",
    msgAntiguaandBarbuda: "Antigua és Barbuda",
    msgArgentina: "Argentína",
    msgArmenia: "Örményország",
    msgAruba: "Aruba",
    msgAustralia: "Ausztrália",
    msgAustria: "Ausztria",
    msgAzerbaijan: "Azerbajdzsán",
    msgBahamas: "Bahamák",
    msgBahrain: "Bahrein",
    msgBangladesh: "Banglades",
    msgBarbados: "Barbados",
    msgBelarus: "Fehéroroszország",
    msgBelgium: "Belgium",
    msgBelize: "Belize",
    msgBenin: "Benin",
    msgBermuda: "Bermuda",
    msgBhutan: "Bhután",
    msgBolivia: "Bolívia",
    msgBosniaHerzegovina: "Bosznia és Hercegovina",
    msgBotswana: "Botswana",
    msgBouvetIsland: "Bouvet-sziget",
    msgBrazil: "Brazília",
    msgBritishIndian: "Brit Indiai-óceáni Terület",
    msgBrunei: "Brunei",
    msgBulgaria: "Bulgária",
    msgBurkinaFaso: "Burkina Faso",
    msgBurundi: "Burundi",
    msgCambodia: "Kambodzsa",
    msgCameroon: "Kamerun",
    msgCanada: "Kanada",
    msgCapeVerde: "Zöld-foki Köztársaság",
    msgCaymanIslands: "Kajmán-szigetek",
    msgCentralAfrican: "Közép-afrikai Köztársaság",
    msgChad: "Csád",
    msgChile: "Chile",
    msgChina: "Kína",
    msgChristmasIsland: "Karácsony-sziget",
    msgCocosIslands: "Kókusz (Keeling)-szigetek",
    msgColombia: "Kolumbia",
    msgComoros: "Comore-szigetek",
    msgCongo: "Kongó",
    msgRepublicCongo: "Kongói Demokratikus Köztársaság",
    msgCookIslands: "Cook-szigetek",
    msgCostaRica: "Costa Rica",
    msgIvoryCoast: "Elefántcsontpart",
    msgCroatia: "Horvátország",
    msgCuba: "Kuba",
    msgCyprus: "Ciprus",
    msgCzechRepublic: "Cseh Köztársaság",
    msgDenmark: "Dánia",
    msgDjibouti: "Dzsibuti",
    msgDominica: "Dominika",
    msgDominicanRepublic: "Dominikai Köztársaság",
    msgEastTimor: "Kelet-Timor",
    msgEcuador: "Ecuador",
    msgEgypt: "Egyiptom",
    msgEngland: "Anglia",
    msgElSalvador: "Salvador",
    msgEquatorialGuinea: "Egyenlítői-Guinea",
    msgEritrea: "Eritrea",
    msgEstonia: "Észtország",
    msgEthiopia: "Etiópia",
    msgFalklandIslands: "Falkland-szigetek",
    msgFaroeIslands: "Feröer-szigetek",
    msgFijiIslands: "Fidzsi-szigetek",
    msgFinland: "Finnország",
    msgFrance: "Franciaország",
    msgFrenchGuiana: "Francia Guyana",
    msgFrenchPolynesia: "Francia Polinézia",
    msgFrenchSouthern: "Francia Déli Területek",
    msgGabon: "Gabon",
    msgGambia: "Gambia",
    msgGeorgia: "Grúzia",
    msgGermany: "Németország",
    msgGhana: "Ghána",
    msgGibraltar: "Gibraltár",
    msgGreece: "Görögország",
    msgGreenland: "Grönland",
    msgGrenada: "Grenada",
    msgGuadeloupe: "Guadeloupe",
    msgGuam: "Guam",
    msgGuatemala: "Guatemala",
    msgGuernsey: "Guernsey",
    msgGuinea: "Guinea",
    msgGuineaBissau: "Bissau-Guinea",
    msgGuyana: "Guyana",
    msgHaiti: "Haiti",
    msgHeardMcDonald: "Heard-sziget és McDonald-szigetek",
    msgHolySee: "Vatikánváros",
    msgHonduras: "Honduras",
    msgHongKong: "Hongkong",
    msgHungary: "Magyarország",
    msgIceland: "Izland",
    msgIndia: "India",
    msgIndonesia: "Indonézia",
    msgIran: "Irán",
    msgIraq: "Irak",
    msgIreland: "Írország",
    msgIsrael: "Izrael",
    msgIsleMan: "Man-sziget",
    msgItaly: "Olaszország",
    msgJamaica: "Jamaica",
    msgJapan: "Japán",
    msgJersey: "Jersey",
    msgJordan: "Jordánia",
    msgKazakhstan: "Kazahsztán",
    msgKenya: "Kenya",
    msgKiribati: "Kiribati",
    msgKuwait: "Kuvait",
    msgKyrgyzstan: "Kirgizisztán",
    msgLaos: "Laosz",
    msgLatvia: "Lettország",
    msgLebanon: "Libanon",
    msgLesotho: "Lesotho",
    msgLiberia: "Libéria",
    msgLibyanJamahiriya: "Líbia",
    msgLiechtenstein: "Liechtenstein",
    msgLithuania: "Litvánia",
    msgLuxembourg: "Luxemburg",
    msgMacao: "Makaó",
    msgNorthMacedonia: "Észak-Macedónia",
    msgMadagascar: "Madagaszkár",
    msgMalawi: "Malawi",
    msgMalaysia: "Malajzia",
    msgMaldives: "Maldív-szigetek",
    msgMali: "Mali",
    msgMalta: "Málta",
    msgMarshallIslands: "Marshall-szigetek",
    msgMartinique: "Martinique",
    msgMauritania: "Mauritánia",
    msgMauritius: "Mauritius",
    msgMayotte: "Mayotte",
    msgMexico: "Mexikó",
    msgMicronesia: "Mikronézia, Szövetségi Államok",
    msgMoldova: "Moldova",
    msgMonaco: "Monaco",
    msgMongolia: "Mongólia",
    msgMontserrat: "Montserrat",
    msgMontenegro: "Montenegró",
    msgMorocco: "Marokkó",
    msgMozambique: "Mozambik",
    msgMyanmar: "Mianmar",
    msgNamibia: "Namíbia",
    msgNauru: "Nauru",
    msgNepal: "Nepál",
    msgNetherlands: "Hollandia",
    msgNetherlandsAntilles: "Holland Antillák",
    msgNewCaledonia: "Új-Kaledónia",
    msgNewZealand: "Új-Zéland",
    msgNicaragua: "Nicaragua",
    msgNiger: "Niger",
    msgNigeria: "Nigéria",
    msgNiue: "Niue",
    msgNorfolkIsland: "Norfolk-sziget",
    msgNorthKorea: "Észak-Korea",
    msgNorthernIreland: "Észak-Írország",
    msgNorthernMariana: "Északi-Mariana-szigetek",
    msgNorway: "Norvégia",
    msgOman: "Omán",
    msgPakistan: "Pakisztán",
    msgPalau: "Palau",
    msgPalestine: "Palesztina",
    msgPanama: "Panama",
    msgPapua: "Pápua Új-Guinea",
    msgParaguay: "Paraguay",
    msgPeru: "Peru",
    msgPhilippines: "Fülöp-szigetek",
    msgPitcairn: "Pitcairn",
    msgPoland: "Lengyelország",
    msgPortugal: "Portugália",
    msgPuertoRico: "Puerto Rico",
    msgQatar: "Katar",
    msgReunion: "Réunion",
    msgRomania: "Románia",
    msgRussianFederation: "Orosz Föderáció",
    msgRwanda: "Ruanda",
    msgSaintHelena: "Szent Ilona",
    msgSaintKitts: "Saint Kitts és Nevis",
    msgSaintLucia: "Saint Lucia",
    msgSaintPierre: "Saint Pierre és Miquelon",
    msgSaintVincent: "Saint Vincent és a Grenadine-szigetek",
    msgSamoa: "Szamoa",
    msgSanMarino: "San Marino",
    msgSaoTome: "São Tomé és Príncipe",
    msgSaudiArabia: "Szaúd-Arábia",
    msgScotland: "Skócia",
    msgSenegal: "Szenegál",
    msgSerbia: "Szerbia",
    msgSeychelles: "Seychelle-szigetek",
    msgSierraLeone: "Sierra Leone",
    msgSingapore: "Szingapúr",
    msgSlovakia: "Szlovákia",
    msgSlovenia: "Szlovénia",
    msgSolomonIslands: "Salamon-szigetek",
    msgSomalia: "Szomália",
    msgSouthAfrica: "Dél-afrikai Köztársaság",
    msgSouthSandwich: "Dél-Georgia és Déli-Sandwich-szigetek",
    msgSouthKorea: "Dél-Korea",
    msgSouthSudan: "Dél-Szudán",
    msgSpain: "Spanyolország",
    msgSriLanka: "Srí Lanka",
    msgSudan: "Szudán",
    msgSuriname: "Suriname",
    msgSvalbardJan: "Svalbard és Jan Mayen",
    msgSwaziland: "Szváziföld",
    msgSweden: "Svédország",
    msgSwitzerland: "Svájc",
    msgSyria: "Szíria",
    msgTajikistan: "Tádzsikisztán",
    msgTanzania: "Tanzánia",
    msgThailand: "Thaiföld",
    msgTimorLeste: "Kelet-Timor",
    msgTogo: "Togo",
    msgTokelau: "Tokelau",
    msgTonga: "Tonga",
    msgTrinidadTobago: "Trinidad és Tobago",
    msgTunisia: "Tunézia",
    msgTurkey: "Törökország",
    msgTurkmenistan: "Türkmenisztán",
    msgTurksCaicos: "Turks- és Caicos-szigetek",
    msgTuvalu: "Tuvalu",
    msgUganda: "Uganda",
    msgUkraine: "Ukrajna",
    msgUnitedArabEmirates: "Egyesült Arab Emírségek",
    msgUnitedKingdom: "Egyesült Királyság",
    msgUnitedStates: "Egyesült Államok",
    msgUnitedStatesMinor: "Amerikai Egyesült Államok Külső Szigetei",
    msgUruguay: "Uruguay",
    msgUzbekistan: "Üzbegisztán",
    msgVanuatu: "Vanuatu",
    msgVenezuela: "Venezuela",
    msgVietnam: "Vietnám",
    msgVirginIslandsBritish: "Brit Virgin-szigetek",
    msgVirginIslandsUS: "Amerikai Virgin-szigetek",
    msgWales: "Wales",
    msgWallisFutuna: "Wallis és Futuna",
    msgWesternSahara: "Nyugat-Szahara",
    msgYemen: "Jemen",
    msgZambia: "Zambia",
    msgZimbabwe: "Zimbabwe",
}

export default hu;